import { css } from "@linaria/core"
import { styled } from "@linaria/react"
import { observer } from "mobx-react-lite"
import { useMemo } from "react"


import { defaultDiffTheme } from "@/components/Diff/diffColors.ts"
import { DiffModel } from "@/components/Diff/DiffModel.ts"
import { DiffPartComponent } from "@/components/Diff/DiffPart.tsx"
import { useMediaQuery } from "@/hooks/useMediaQuery.ts"
import { useModel } from "@/hooks/useModel.ts"
import { mobileBreakpoint } from "@/styles/mixins.ts"

import type { DiffTheme } from "@/components/Diff/diffColors.ts"
import type { InlineDiff } from "@/lib/client/generated/TypeDefinitions.ts"
import type { Property } from "csstype"
import type { IObservableValue } from "mobx"

export const DiffComponent = observer((props: {
  data: InlineDiff
  theme?: DiffTheme
  panelWidth?: () => Property.Width
  gutterWidth?: IObservableValue<Property.Width>
  maxHeight?: Property.MaxHeight
}) => {
  const isMobile = useMediaQuery(mobileBreakpoint)

  const vm = useModel(() => new DiffModel(props.data, isMobile, props.panelWidth, props.gutterWidth), [props.data, isMobile, props.gutterWidth])
  const theme = useMemo(() => props.theme || defaultDiffTheme(), [props.theme])

  return (
    <Container ref={vm.refCallback} width={vm.width.get()} maxHeight={props.maxHeight} className={DiffContainerMarker}>
      <Scrollable>
        {vm.parts.get().map(part => (
          <DiffPartComponent
            key={part.key}
            value={part}
            theme={theme}
            gutterWidth={vm.gutterWidth}
          />
        ))}
      </Scrollable>
    </Container>
  )
})

export const DiffContainerMarker = css`
`

const Container = styled.div<{
  width: Property.Width
  maxHeight?: Property.MaxHeight
}>`
  overflow: auto;

  width: ${props => props.width};
  max-height: ${props => props.maxHeight ?? "none"};
`

const Scrollable = styled.div`
  width: max-content;
  min-width: 100%;
`